<template>
	<v-dialog v-model="dialog" max-width="500px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase" icon v-on="on">
				<v-tooltip bottom color="primary">
					<template v-slot:activator="{ on }">
						<v-icon v-on="on">mdi-storefront-minus-outline</v-icon>
					</template>
					<span>{{'remove from chain' | localize}}</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-if="!loading">
			<v-card-title class="subtitle-1 pt-6 text-pre-wrap">
				{{'Would you like to remove all trademarks from the' | localize}} <span class="secondary--text">{{ this.channel.name }}</span>? &#128580;
			</v-card-title>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="error" text
					class="text-capitalize"
					@click="deleteChannel">
					{{'Yes' | localize }}
				</v-btn>
				<v-btn color="secondary" text
					class="text-capitalize"
					@click="closeDialog">
					{{'No' | localize }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

	export default {
		props: ['channel'],
		data () {
			return	{
				dialog: false
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			locale () {
				return this.$store.getters.locale;
			}
		},
		methods: {
			async deleteChannel () {
				await this.$store.dispatch('deleteChannel', this.channel.id);
				this.closeDialog()
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''
			}
		},
	}
</script>
